import React from "react";
import "./ArtistServices.scss";

const ArtistServices = ({
  smallTitle = "",
  title = "",
  subtitle = "",
  paragraphs = [],
  align = "left",
}) => {
  return (
    <section className={`artist-services artist-services--${align}`}>
      <div className="artist-services__container">
        {smallTitle && (
          <span className="artist-services__small-title">{smallTitle}</span>
        )}

        <h2 className="artist-services__title">{title}</h2>

        {subtitle && <p className="artist-services__subtitle">{subtitle}</p>}

        <div className="artist-services__content">
          {paragraphs.map((text, index) => (
            <p key={index}>{text}</p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArtistServices;
